import {createBackendEditor, referenceActionData} from '../../form/ComponentEditor';
import OperationListEditor from './OperationListEditor';
import {ProductColumn, UnitFormatter, UpdatedByFormatter, UserFormatter} from "../../../utils/formatters";
import {postData} from "../../../utils/request";
import React, {Fragment} from "react";
import TextInput from "../../form/TextInput";
import {ifCompletedInput} from "../../../utils/other";
import ShopReturnGoodsForm from "./Elements/ShopReturnGoodsForm";
import Button from "../../form/Button";
import CheckBox from "../../form/CheckBox";
import {PriceView} from "../../classes/Price";

const sortable = true;
const filterable = true;

class ShopReturnGoodsEditor extends React.Component {

    state = {
        filtered: false,
        componentEditor: "ShopReturnGoods",
        filter: [
            {column: "preset", value: "ShopReturnGoods"},
            {column: "saved", value: 1}
        ],
        hidden: ["discount","pos","invoice","payment"/*, "source"*/],
        labels: {customer: " ", seller: "Partner"},
        disabled: ["customer"],
        actionButtons: [],
        pool: {
            orderBy: {field: "displayname", direction: "ASC"},
            selection: [],
            pageSize: 5,
            pageSizes: [5,10,15,20,50],
            aggregations: {
                fields: {
                    "count": {
                        field: "pickedqty", type: "COUNT"
                    },
                    "pickedqty": {
                        field: "pickedqty", type: "SUM"
                    },
                }
            },
            component: "OperationProductPoolItem",
            view: ["id","product_id","OperationList_id", "vat", "component_type", "component_id", ...PriceView("saleprice"), "saleprice", ...PriceView("listprice"), "listprice"],
            columns: {
                "displayname": {
                    ...ProductColumn("component_id"),
                    width: 1,
                },
                "barcode": {
                    header: 'Vonalkód',
                    width: 1,
                    sortable,
                    filterable
                },
                "stockqty": {
                    header: 'Raktárkészlet',
                    width: 1,
                    sortable,
                    filterable,
                    renderer: (value, row) => UnitFormatter(value, row.unit),
                    className: "unit"
                },
                "pickedqty": {
                    header: "Darabszám",
                    width: 1,
                    renderer: (value, row) => UnitFormatter(value, row.unit),
                    sortable,
                    filterable,
                    aggregation: (value, row) => {
                        return <Fragment><span className="unit">Összesen: {UnitFormatter(row.pickedqty || 0, row.unit).props.children}</span><span className="unit">Tétel: {UnitFormatter(row.count || 0, row.unit).props.children}</span></Fragment>;
                    },
                    className: "unit",
                    editor:
                        (parent) =>
                            (props, value) =>
                                <TextInput type="number" name="pickedqty" label={false} value={value} focus
                                           onKeyDown={(e, field, value) => {ifCompletedInput(e) && parent.onEditorValueChange(props, value);}}
                                           onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                },
            }
        }
    };

    promisedSetState = (newState) => {
        return new Promise((resolve) => {
            this.setState(newState, () => {
                resolve()
            });
        });
    }

    constructor(props) {
        super(props);
    }

    getProps = () => {
        const props = {
            ...this.props,
            ...this.state,
        };
        props.actionButtons = [
            <Button key="4" type="button" disabled={ props.isLoading || !props.values.id } color="primary" icon={{lib: "fa", name: "truck"}} className="pull-right" onClick={ async (e) => {
                const values = props.values;
                values.autocheckup = true;
                await props.processAction(async () => {
                    const response = await postData({
                        action: 'OperationList.doAction',
                        actionname: 'create',
                        data: await referenceActionData(values, this.props.componentConfig)
                    });
                    await this.props.pristineForm(false);
                    return response;
                });
            }}>
                Visszáru
            </Button>
        ];
        props.pool.parameters = {};
        props.pool.reqparams = {};
        if (props.values && props.values.seller && props.values.source) {
            props.pool.visible = true;
            props.pool.parameters.discount_type = "purchase";
            props.pool.parameters.partner = props.values.seller.partner_id;
            props.pool.parameters.store = props.values.source.id;
            props.pool.parameters.OperationList_id = props.values.id;
            props.pool.parameters.seller = props.values.seller.partner_id;
            props.pool.parameters.customer = props.values.seller.partner_id;
        } else {
            props.pool.visible = false;
        }
        props.filtered = this.state.filtered;
        if (this.state.filtered) {
            props.pool.filter = [{field: "pickedqty", operator: "not isnull"}];
        } else {
            props.pool.filter = [];
        }
        props.pool.paginatorRight = <CheckBox onIcon={{lib: "fa", name: "box"}} offIcon={{lib: "fa", name: "box-open"}} value={this.state.filtered} label={false} saveChanges={(field, value) => {
            this.setState({filtered: !!value});
        }} />;
        return props;
    }

    renderer = (componentProps) => {
        return <ShopReturnGoodsForm {...componentProps} />;
    }

    render() {
        const props = this.getProps();
        return <OperationListEditor {...props} renderer={this.renderer} />;
    }

}

export default createBackendEditor({
    componentName: "OperationList",
    WrappedComponent: ShopReturnGoodsEditor,
    editor: "ShopReturnGoods",
    dirtyFlag: (values) => {
        return !parseInt(values.saved) && values.id;
    },
    props: {
        componentActions: async (action, data, params, componentConfig) => {
            params.preset = "ShopReturnGoods";
            data = await referenceActionData(data, componentConfig);
            return {action,data,params};
        }
    }
});